var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.f3 != 1),expression:"f3 != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"screan"}},[_c('img',{attrs:{"src":require("../assets/img/light/screan.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.f3 != 1),expression:"f3 != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"tou"}},[_c('img',{attrs:{"src":require("../assets/img/tou1.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.f3 != 1),expression:"f3 != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"ai"}},[_c('img',{attrs:{"src":require("../assets/img/ai.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"lightBlue"}},[_c('img',{attrs:{"src":require("../assets/img/car/lightBlue.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"lightWhite"}},[_c('img',{attrs:{"src":require("../assets/img/car/lightWhite.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.f3 != 1),expression:"f3 != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"F3"}},[_c('img',{attrs:{"src":require("../assets/img/car/f3.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"F4"}},[_c('img',{attrs:{"src":require("../assets/img/car/f4.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"F2"}},[_c('img',{attrs:{"src":require("../assets/img/car/f2.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"f1White"}},[_c('img',{attrs:{"src":require("../assets/img/car/f1White.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"f1Blue"}},[_c('img',{attrs:{"src":require("../assets/img/car/f1Blue.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"wheelWhite"}},[_c('img',{attrs:{"src":require("../assets/img/car/wheelWhite.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"wheelBlack"}},[_c('img',{attrs:{"src":require("../assets/img/car/wheelBlack.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"light"}},[_c('img',{attrs:{"src":require("../assets/img/car/light.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.f3 == 1),expression:"f3 == 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTou: _vm.setTou,
				getTou: _vm.getTou,
				setAi: _vm.setAi,
				getAi: _vm.getAi,
				setScrean: _vm.setScrean,
				getScrean: _vm.getScrean,
				setlightWhite: _vm.setlightWhite,
				getlightWhite: _vm.getlightWhite,
				setlightBlue: _vm.setlightBlue,
				getlightBlue: _vm.getlightBlue,
				setf1White: _vm.setf1White,
				getf1White: _vm.getf1White,
				setF4: _vm.setF4,
				getF4: _vm.getF4,
				setF2: _vm.setF2,
				getF2: _vm.getF2,
				setLight: _vm.setLight,
				getLight: _vm.getLight,
				setwheelWhite: _vm.setwheelWhite,
				getwheelWhite: _vm.getwheelWhite,
				setwheelBlack: _vm.setwheelBlack,
				getwheelBlack: _vm.getwheelBlack,
				setF3: _vm.setF3,
				getF3: _vm.getF3,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTou,\n\t\t\t\tgetTou,\n\t\t\t\tsetAi,\n\t\t\t\tgetAi,\n\t\t\t\tsetScrean,\n\t\t\t\tgetScrean,\n\t\t\t\tsetlightWhite,\n\t\t\t\tgetlightWhite,\n\t\t\t\tsetlightBlue,\n\t\t\t\tgetlightBlue,\n\t\t\t\tsetf1White,\n\t\t\t\tgetf1White,\n\t\t\t\tsetF4,\n\t\t\t\tgetF4,\n\t\t\t\tsetF2,\n\t\t\t\tgetF2,\n\t\t\t\tsetLight,\n\t\t\t\tgetLight,\n\t\t\t\tsetwheelWhite,\n\t\t\t\tgetwheelWhite,\n\t\t\t\tsetwheelBlack,\n\t\t\t\tgetwheelBlack,\n\t\t\t\tsetF3,\n\t\t\t\tgetF3,\n\t\t\t}"}],attrs:{"id":"line"}},[_c('img',{attrs:{"src":require("../assets/img/car/line.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/car/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9a64d1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/car.vue
// module id = null
// module chunks = 